import { useQuery } from "@tanstack/react-query";
import { GetPartnerConfigurationResponseV2 } from "api/client.generated";
import useApi from "../useApi";

interface useSourcePartnerConfigurationReturn {
  sourcePartnerConfiguration: GetPartnerConfigurationResponseV2 | undefined;
  isSourcePartnerConfigurationFetching: boolean;
}

const useSourcePartnerConfiguration = (): useSourcePartnerConfigurationReturn => {
  const { partnersMigrationClient } = useApi();

  const { data, isFetching } = useQuery({
    queryKey: ["getSourcePartnerConfiguration"],
    queryFn: () => partnersMigrationClient.getSourcePartnerConfiguration(),
  });

  return { sourcePartnerConfiguration: data, isSourcePartnerConfigurationFetching: isFetching };
};

export default useSourcePartnerConfiguration;
